import { FoodItemResponse, FoodItemResponseItem} from '@/types/service-response'
import Tag, { TagModel } from '@/model/tennant/Tag'
import DailyMenuOptionOffer from "@/model/dailymenu/DailyMenuOptionOffer";
import Allergen from "@/model/food-database/Allergen";
import FoodItemImage from "@/model/food-database/FoodItemImage";

export interface FoodItemModel {
   id: number,
   createdAt: Date,
   name: string,
   tags: Tag[],
   price: string,
   title: string,
   description: string,
   energy: string,
   weight: string,
   allergens: Allergen[]
   recipe: string
   energyUnit: string
    media: string[]
}

export default class FoodItem implements FoodItemModel {
  private constructor (

    readonly id: number,
    readonly createdAt: Date,
    readonly name: string,
    readonly tags: Tag[],
    readonly price: string,
    readonly title: string,
    readonly description: string,
    readonly energy: string,
    readonly weight: string,
    readonly allergens: Allergen[],
    readonly recipe: string,
    readonly energyUnit: string,
    readonly media: string[]

) {
  }

  public static createEmpty(): FoodItem {
    const unit: string = localStorage.getItem('energyUnit') || 'kcal'
    return new FoodItem(0, new Date, '', [],'','','','','',[],'', unit,[])
  }

  public static createEmptyWithName(name: string): FoodItem {
      const unit: string = localStorage.getItem('energyUnit') || 'kcal'
      return new FoodItem(0, new Date, name, [],'','','','','',[],'', unit,[])
  }

  public static createFromResponse (response: FoodItemResponse): FoodItem[] {
    return response.map((i: FoodItemResponseItem) => {
      const tagCollection: Tag[] = i.tags.map((i: TagModel) => Tag.createFromModel(i))
        const allergens: Allergen[] = Allergen.createFromResponse(i.allergens)

      return new FoodItem(
        i.id,
        new Date(i.createdAt),
        i.name,
        tagCollection,
        i.price,
        i.title,
        i.description,
        i.energy && i.energy.split(' ')[0] ? i.energy.split(' ')[0] : '',
        i.weight,
        allergens,
        i.recipe,
          i.energy && i.energy.split(' ')[1] ? i.energy.split(' ')[1] : '',
          i.media
      )
    })
  }

  public static createFromModel(model: FoodItemModel): FoodItem {
    return new FoodItem(
        model.id,
        model.createdAt,
        model.name,
        model.tags,
        model.price,
        model.title,
        model.description,
        model.energy && model.energy.split(' ')[0] ?  model.energy.split(' ')[0] : '',
        model.weight,
        model.allergens,
        model.recipe,
        model.energy && model.energy.split(' ')[1] ? model.energy.split(' ')[1] : '',
        model.media
    )
  }

  /*static convertToFoodItem(data: DailyMenuOptionOffer, tag: Tag[]): FoodItem {
    return {
      id: parseInt(data.id),
      createdAt: new Date,
      name: data.foodItem.name,
    }
  }*/
}